const PREFIX = 'bravissimo/layer/';
export const OPEN_LAYER = `${PREFIX}OPEN_LAYER`;
export const CLOSE_LAYER = `${PREFIX}CLOSE_LAYER`;
